import React, { useState } from "react";

const Rectangle = (props) => {
  //========================================================================
  // Zustandsvariablen definieren

  //========================================================================
  //
  let borderWidth;
  if (props.style.borderWidth === "NaNpx") {
    borderWidth = "0px";
  } else {
    borderWidth = props.style.borderWidth;
  }
  const left = `calc(${props.style.left} - ${borderWidth})`;
  const top = `calc(${props.style.top} - ${borderWidth})`;
  const right = `calc(${props.style.right} - ${borderWidth})`;
  const bottom = `calc(${props.style.bottom} - ${borderWidth})`;

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        visibility: props.props.visibility,
        position: "absolute",
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        borderWidth: borderWidth,
      }}
    ></div>
  );
};

export default Rectangle;
